import { InstanceScreen } from 'component/navigation/instance';

export default function ModerationDashboardPostsScreen() {
    return <InstanceScreen screenKey='posts' />;
}
